<!-- The live region stays in the page, so that screen readers announce what appears in it -->
<div class="announcements" aria-live="polite">
  @for (announcement of announcementService.visible(); track announcement.id) {
    <div class="alert alert-{{ announcement.severity }} announcement" [attr.role]="announcement.severity === 'info' ? null : 'alert'"
      *transloco="let t; scope: announcement.scope">
      <div class="container d-flex align-items-center gap-3">
        <span class="me-auto">{{ t(announcement.message) }}</span>
        @if (announcement.action; as action) {
          <button type="button" class="btn btn-sm btn-primary" (click)="action.run()">{{ t(action.label) }}</button>
        }
        @if (announcement.closable) {
          <button type="button" class="btn-close" [attr.aria-label]="t('common.close')" [tooltip]="t('common.close')"
            placement="bottom" (click)="announcementService.close(announcement.id)"></button>
        }
      </div>
    </div>
  }
</div>
